import React from 'react';
import BaseModal, {
	BaseModalProps,
} from '../../../Base/Components/BaseModal/BaseModal';
import ManagerCalendarViewSettings, {
	CalendarViewSettingsFields,
} from '../../../Manager/Components/ManagerWrapper/Calendar/ManagerCalendarViewSettings/ManagerCalendarViewSettings';
import { CustomSettingKey } from '../../../Base/Enums/CustomSettingKey.enum';

interface Props extends BaseModalProps {
	userId: string;
	onSubmit: () => void;
	customSettingKey: CustomSettingKey;
	allowedFields?: CalendarViewSettingsFields;
}

const CalendarSettingsModal: React.FC<Props> = props => {
	return (
		<BaseModal
			{...props}
			title='component.workplaceCalendarToolbar.calendarSettings'>
			<ManagerCalendarViewSettings
				userId={props.userId}
				onSubmit={props.onSubmit}
				customSettingKey={props.customSettingKey}
				allowedFields={props.allowedFields}
			/>
		</BaseModal>
	);
};

export default CalendarSettingsModal;
